var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiners(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x39_0-diners-club_x2C__Credit_card"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M431.468,83.665H80.532c-19.893,0-36.033,16.141-36.033,36.034v272.602    c0,19.895,16.14,36.035,36.033,36.035h350.936c19.894,0,36.033-16.141,36.033-36.035V119.699    C467.501,99.805,451.361,83.665,431.468,83.665z",
    style: {
      fill: "#0068A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.244,382.9h-67.788c-79.724,0-138.357-51.227-138.357-124.697    c0-80.419,58.633-129.104,138.357-129.104h67.788c78.822,0,141.656,48.685,141.656,129.104    C429.9,331.674,367.066,382.9,288.244,382.9z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.682,162.342c-52.018,0-94.373,42.194-94.373,94.372c0,52.016,42.355,94.372,94.373,94.372    c52.179,0,94.371-42.355,94.371-94.372C315.053,204.536,272.86,162.342,220.682,162.342z",
    style: {
      fill: "#0068A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.262,312.436c-22.385-8.535-38.328-30.277-38.328-55.721c0-25.445,15.943-47.186,38.328-55.882    V312.436z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.101,312.598V200.832c22.386,8.697,38.329,30.437,38.329,55.882    C280.43,282.158,264.486,303.9,242.101,312.598L242.101,312.598z",
    style: {
      fill: "#FFFFFF"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiners);
export default __webpack_public_path__ + "static/media/diners.a9db766ff20b6c6b8d0c2186877956c3.svg";
export { ForwardRef as ReactComponent };